import GlobeIcon from '@atlaskit/icon/core/globe';
import * as React from 'react';

export function SvgGlobe() {
  return <GlobeIcon label="" testId="ads-refreshed-icon" />;
}
